import pngicon from "../../../../src/assests/imgs/png.svg";
import pdficon from "../../../../src/assests/imgs/pdf.svg";
import docicon from "../../../../src/assests/imgs/doc.svg";
import ppticon from "../../../../src/assests/imgs/ppt1.svg";
import xlsicon from "../../../../src/assests/imgs/xlsx.svg";
import zipicon from "../../../../src/assests/imgs/zip.svg";

export default function DisplayFileProper({ item }) {

  const getFileName = (item) => {
    if (!item) return null;

    if (item.fileName) return item.fileName;

    if (item.file) {
      try {
        const url = new URL(item.file);
        return url.pathname.split("/").pop();
      } catch (e) {
        const urlParts = item.file.split("/");
        return urlParts[urlParts.length - 1];
      }
    }

    return null;
  };

  const getFileIcon = (fileName) => {
    if (!fileName) return pdficon;

    const extension = fileName.split(".").pop()?.toLowerCase();

    switch (extension) {
      case "pdf":
        return pdficon;
      case "txt":
      case "doc":
      case "docx":
        return docicon;
      case "ppt":
      case "pptx":
        return ppticon;
      case "xls":
      case "xlsx":
        return xlsicon;
      case "zip":
      case "rar":
      case "7z":
        return zipicon;
      default:
        return pdficon; // fallback
    }
  };

  const fileName = getFileName(item);
  const extension = fileName?.split(".").pop()?.toLowerCase();

  const isImageFile = ["jpg", "jpeg", "png", "gif", "webp"].includes(extension);

  const displaySrc = isImageFile ? item.file : getFileIcon(fileName);

  const handleImageError = (e) => {
    e.target.src = getFileIcon(fileName);
  };

  return (
    <div className="height-img">
      <img
        src={displaySrc}
        // style={{objectFit:'contain'}}
        className="cover-img w-100"
        alt="Certificate"
        onError={handleImageError}
      />
    </div>
  );
}